import MigrationDetailDTO from '@src/adapters/dto/migration/MigrationDetailDTO';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import { useEffect, useState } from 'react';
import { useSaveMigrationItemProcedureLazy } from '@src/adapters/hooks/migration/useSaveMigrationItemProcedure';
import ProcedureAutoComplete from '@src/components/procedure/ProcedureAutoComplete';

interface Props {
  migration: MigrationDetailDTO;
  disabled?: boolean;
  procedureUpdated(procedure: IdNameDto): void;
}

function Procedure({ disabled, migration, procedureUpdated }: Props) {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { execute } = useSaveMigrationItemProcedureLazy();

  useEffect(() => {
    if (migration.procedure) {
      setSelectedId(migration.procedure.id);
    }
  }, [migration.procedure]);

  const handleSelection = (procedureId: string | null) => {
    if (procedureId) {
      saveProcedure(procedureId);
    } else {
      setSelectedId(null);
    }
  };

  const saveProcedure = (id: string) => {
    execute({
      migrationId: migration.id,
      procedureId: id,
    }).then((response) => {
      setSelectedId(id);
      procedureUpdated({ id: id, name: '' });
    });
  };

  return (
    <ProcedureAutoComplete
      onSelection={handleSelection}
      selectedId={selectedId}
      enableNew={true}
      disabled={disabled}
    />
  );
}

export default Procedure;
